import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  BackButton,
  ListPanel,
  DescriptionBox,
  ZeroState,
  getFormattedDateTime,
} from 'ecs-react-components/dist/index.es';
import {
  loadTestResults,
  loadTestResultDetails,
} from '../../redux/modules/test-results/test-results-middleware';
import * as actions from '../../redux/modules/test-results/test-results-action-creators';
import { messages } from './TestResults.i18n';
import { TestResultDetails } from './TestResultDetails';
import TestResultsFilters from './TestResultsFilters';
import { generateListItems } from './ListItemsConfig';
import Header from '../../components/Header/Header';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';

class TestResultsCompact extends React.Component {
  constructor(props) {
    super(props);
    this.listItems = [];
    this.state = {
      isListView: true,
    };
  }

  UNSAFE_componentWillMount() {
    this.listItems = generateListItems(this.props.testResults, this.props.language);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.listItems = generateListItems(nextProps.testResults, this.props.language);
  }

  getDescriptionBoxContent() {
    const {
      language,
      testResult: {
        startDate,
        requestingPhysician,
        labName,
        noteToPatient,
      },
    } = this.props;
    const dateParts = getFormattedDateTime(startDate, startDate, language);
    return (
      <div>
        <p id="test_procedure_date_collected">
          <FormattedMessage { ...messages.page.dateCollected } />
          {dateParts.datePart}
        </p>
        <p id="test_procedure_ordered_by">
          <FormattedMessage { ...messages.page.orderedBy } />
          {requestingPhysician}
        </p>
        <p id="test_procedure_lab">
          <FormattedMessage { ...messages.page.lab } />
          {labName}
        </p>
        <br />
        {
          this.props.testResult.noteToPatient ?
            <p id="test_procedure_remarks">
              <FormattedMessage { ...messages.page.remarks } />
              {noteToPatient}
            </p>
            : ''
        }
      </div>);
  }

  handleListItemClick = (activeIndex) => {
    this.props.dispatch(actions.selectedTestResultChanged(activeIndex));

    this.props.dispatch(loadTestResultDetails(this.props.patientId, this.listItems[activeIndex].itemId)).then(() => {
      // Make this call so that the 'isNew' badge is updated.
      this.props.dispatch(loadTestResults(this.props.patientId));

      if (this.state.isListView) {
        this.state.isListView = false;
      }
    });
  }

  handleBackButtonClick = () => {
    this.setState({ isListView: true });
  }


  renderZeroStateContainer() {
    return (
      <ZeroState
        zeroStateMessage={ <FormattedMessage { ...messages.page.zeroStateMessage } /> }
        stateIconCss="fa-regular fa-file-lines"
      />
    );
  }

  renderTestResultsList() {
    return (
      <div className="row g-0">
        <ListPanel
          items={this.listItems}
          title={messages.listPanel.title}
          handleListItemClick={this.handleListItemClick}
          activeIndex={this.props.activeIndex}
          qaTag="TestProcedureContainer"
          wrapperClassName="col-lg-4 custom-list-wrapper"
        />
      </div>
    );
  }

  renderListView() {
    return (
      <div>
        <Header headerTitle={<FormattedMessage { ...messages.page.title } /> }
          badgeNumber={this.props.badgeNumber}
        />
        <TestResultsFilters
          filteredRows={this.props.testResults ? this.props.testResults.filter((value) => !value.isFiltered).length : 0}
          allRows={this.props.testResults.length || 0}
        />
        <LoadingIndicatorContainer loadingKey="TestResultsCompact" >
          { this.listItems.length > 0 ? this.renderTestResultsList() : this.renderZeroStateContainer() }
        </LoadingIndicatorContainer>
      </div>
    );
  }

  renderDetailsView() {
    return (
      <div id="test-results-details">
        <BackButton buttonName={messages.page.backButton} onClick={this.handleBackButtonClick} />
        <DescriptionBox content={this.getDescriptionBoxContent()} />
        {this.props.labResultGroups.map((group) => (
          <TestResultDetails groupDisplayName={group.groupDisplayName}
            testResultDetails={group.testResultDetails}
            key={group.testResultGroupId}
          />))}
      </div>
    );
  }

  render() {
    return (
      <div className="row" id="test-results-content">
        {this.state.isListView ? this.renderListView() : this.renderDetailsView()}
      </div>
    );
  }
}

TestResultsCompact.propTypes = {
  dispatch: PropTypes.func,
  patientId: PropTypes.string,
  testResults: PropTypes.array,
  testResult: PropTypes.object,
  badgeNumber: PropTypes.number,
  activeIndex: PropTypes.string,
  labResultGroups: PropTypes.array,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  patientId: state.profile.patient.patientId,
  testResults: state.testResults.results,
  testResult: state.testResults.selectedTestResult,
  labResultGroups: state.testResults.selectedTestResult.labResultGroups,
  badgeNumber: state.testResults.notReviewedTestResultsCount,
  activeIndex: state.testResults.selectedTestResultIndex,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(TestResultsCompact);